import { hexToRgba } from "@icarros/utils-react";
import styled, { css } from "styled-components";
import { ids } from "@icarros/theme-react";
const { size, opacity, color } = ids || {};
export const StyledLabel = styled.label `
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: ${size.border_width.ids_size_border_small} solid
    ${color.action.primary.ids_color_action_primary_variant};
  background: ${color.backgrounds.ids_color_bg_base};
  border-radius: ${size.corner_radius.ids_size_cornerRadius_button};

  ${({ isChecked }) => !isChecked &&
    css `
      &:hover,
      &:focus {
        background: ${hexToRgba(color.action.primary.ids_color_action_primary_variant, opacity.ids_opacity_soft)};
      }
    `}

  ${({ isChecked }) => isChecked &&
    css `
      background: ${color.action.primary.ids_color_action_primary_variant};
      span {
        color: ${color.action.primary.ids_color_action_primary_contrast};
      }
    `}
`;
export const StyledInput = styled.input `
  display: none;
  visibility: hidden;
`;
//# sourceMappingURL=RatingNumber.style.js.map